import { useEffect } from 'react';

/**
 * Handles clicks that occur outside of the component.
 * @param {HTMLElement} node - Reference to the component element.
 * @param {func} handler -  The function that is executed when the user clicks outside of the component.
 */
const useOutsideClick = (
  node: HTMLElement | null,
  handler: (event: MouseEvent) => void,
) => {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      // Early return if node isn't available.
      if (node === null) return;

      // Invokes callback function if the click target
      // doesn't contain the node.
      if (node && !node.contains(event.target as Element)) {
        event.stopPropagation();
        return handler(event);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [node, handler]);
};

export default useOutsideClick;
